<template>
  <div>
    <h1>创建新闻分类</h1>
    <el-form label-width="120px" @submit.native.prevent="saveNewsCate">
      <el-form-item label="分类名称">
        <el-input v-model="model.newsGroupName"></el-input>
      </el-form-item>
      <el-form-item label="新闻分类">
        <el-input v-model="model.newsGroup"></el-input>
      </el-form-item>
      <el-form-item label="newsID(自动生成)">
        <el-input v-model="newsID" @input="createNewsID"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit">点击创建</el-button>
      </el-form-item>
    </el-form>

    <h1>新闻分类列表</h1>
    <el-table :data="newscate" style="width: 100%">
      <el-table-column
        prop="createAt"
        label="创建日期"
        :formatter="formatDate"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="newsGroupName" label="新闻分类" width="180">
      </el-table-column>
      <el-table-column prop="newsGroup" label="所属分组"> </el-table-column>
      <el-table-column prop="newsID" label="分类ID"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            @click="delNewsCate(scope.row.newsID)"
            type="danger"
            size="small"
            plain
            icon="el-icon-delete"
            >删除</el-button
          >
          <el-button
            style="margin: 10px 3px 3px 0px"
            @click="getEditNewsCate(scope.row.newsID)"
            type="primary"
            size="small"
            plain
            icon="el-icon-edit"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 三级分类修改 -->
    <div v-for="item in editNewsCate" :key="item.index">
      <el-dialog
        title="新闻分类修改"
        :visible.sync="newsCateDialog"
        width="45%"
      >
        <el-form>
          <el-form-item label="新闻分类">
            <el-input v-model="item.newsGroupName"> </el-input>
          </el-form-item>
          <el-form-item label="所属分组">
            <el-input v-model="item.newsGroup"> </el-input>
          </el-form-item>

          <el-form-item label="newsID">
            <el-input :disabled="true" v-model="item.newsID"> </el-input>
          </el-form-item>
        </el-form>

        <el-button type="primary" @click="putEditNewsCate(item._id)"
          >点击修改</el-button
        >
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { timerfilter } from "../util/timerfilter";

export default {
  props: {
    maID: {},
  },
  data() {
    return {
      newsCateDialog: false,
      model: {},
      newsID: "",
      newscate: [],
      editNewsCate: [],
    };
  },
  methods: {
    async saveNewsCate() {
      let params = {
        newsGroupName: this.model.newsGroupName,
        newsGroup: this.model.newsGroup,
        newsID: this.newsID,
      };
      try {
        const addnewscate = await this.$http.post("/newscate/create", params);
        if (addnewscate.status === 200) {
          this.$message({
            type: "success",
            message: addnewscate.data.msg,
          });
          this.getNewsCate();
          this.model = [];
          this.createNewsID();
        }
      } catch (error) {
        console.log(error);
      }
    },
    //自动生成新闻ID
    createNewsID() {
      this.newsID = Date.now();
    },
    async getNewsCate() {
      try {
        const getnewscate = await this.$http.get("/newscate/getnewscate");
        this.newscate = getnewscate.data;
      } catch (error) {
        console.log(error);
      }
    },
    delNewsCate(newsID) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
        center: true,
      })
        .then(async () => {
          const res = await this.$http.delete("/newscate/delnewscate", {
            params: { newsID },
          });
          if (res.status === 203) {
            console.log(res.data);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getNewsCate();
          } else {
            this.$message(res.message);
          }
        })
        .catch((res) => {
          if (res === "cancel") {
            this.$message({
              type: "info",
              message: "取消删除",
            });
          } else {
            //console.log(res);
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
    async getEditNewsCate(newID) {
      try {
        this.newsCateDialog = true;
        const result = await this.$http.get(
          "/newscate/getnewsedit?newsID=" + `${newID}`
        );
        this.editNewsCate = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    async putEditNewsCate(id) {
      try {
        this.newsCateDialog = false;
        const result = await this.$http.put(
          "/newscate/putnewsedit?id=" + `${id}`,
          ...this.editNewsCate
        );
        if (result.status == 201) {
          this.$message({
            type: "success",
            message: result.data.msg,
          });
          this.getNewsCate();
        }
      } catch (error) {
        console.log(error);
      }
      //console.log(newID);
    },
    //日期格式化插件
    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
  },
  created() {
    this.createNewsID();
    this.getNewsCate();
  },
};
</script>
